import {
  Smartphone, RefreshCcw, Tablet, Laptop, Monitor, Tv, Watch, Gamepad2, Headphones, Speaker, Camera,
  Keyboard, Mouse, Printer, Router, Wifi, Cable, Usb, Plug, Battery, MemoryStick, HardDrive, Cpu,
  Disc, Wrench, Zap, Lock, ShieldCheck, Package, PhoneCall, Bluetooth, Radio, Antenna, Webcam,
  ScanLine, Projector, MonitorSpeaker, Joystick, Dices, Puzzle, Blocks, Baby, Backpack, Briefcase,
  ShoppingBag, ShoppingCart, Shirt, Footprints, Glasses, Gem, Crown, Palette, Sparkles, Scissors,
  Brush, Droplet, HeartPulse, Stethoscope, Pill, Syringe, Bandage, Thermometer, Dumbbell, Bike, Bus,
  Car, CarFront, Truck, Fuel, Gauge, Cog, Settings, Hammer, Drill, Ruler, Nut, Paintbrush,
  PaintRoller, Axe, Shovel, TreePine, Trees, Flower2, Leaf, Sprout, Apple, Banana, Carrot, Wheat,
  Fish, Beef, Egg, Milk, Cookie, Cake, IceCreamCone, Coffee, CupSoda, Wine, Beer, Martini,
  GlassWater, Utensils, UtensilsCrossed, ChefHat, Soup, Pizza, Sandwich, Croissant, Candy, Popcorn,
  Salad, Drumstick, Ham, Cherry, Home, Building2, Warehouse, DoorOpen, Sofa, Armchair, Bed,
  BedDouble, Lamp, LampDesk, Refrigerator, Microwave, WashingMachine, Fan, Flame, Droplets,
  ShowerHead, Bath, Toilet, Paintbrush2, Frame, ImageIcon, Image, BookOpen, Book, Library,
  NotebookPen, PenTool, Pencil, Eraser, Highlighter, Paperclip, FileText, Folder, Calculator,
  Newspaper, Music, Music2, Guitar, Piano, Mic, Mic2, Film, Clapperboard, Ticket, PartyPopper, Gift,
  GiftIcon, Sparkle, Snowflake, Sun, Umbrella, Waves, Palmtree, Tent, Compass, Map, MapPin, Luggage,
  Plane, Ship, Anchor, Sailboat, Trophy, Medal, Target, Volleyball, Award, Flag, PawPrint, Bone, Cat,
  Dog, Bird, Rabbit, Turtle, Squirrel, Feather, ToyBrick, Users, Star, Tag, Percent, BadgeDollarSign,
  Wallet,
} from "lucide-react";

// Icônes proposées au choix pour illustrer une catégorie de stock. La "value" est
// stockée telle quelle en base (icon_value) et doit rester stable dans le temps.
// Pack de 200 icônes pré-installées couvrant les univers de boutique les plus
// courants (téléphonie/informatique, bricolage, alimentation, mode/beauté,
// maison/déco, sport/loisirs, animalerie...) — voir aussi le champ de recherche
// du sélecteur d'icône (Administrateurs > Catégories) pour en retrouver une
// rapidement dans une aussi longue liste.
export const CATEGORY_ICON_OPTIONS = [
  { value: "Smartphone", label: "Téléphone", Icon: Smartphone },
  { value: "RefreshCcw", label: "Occasion / Reconditionné", Icon: RefreshCcw },
  { value: "Tablet", label: "Tablette", Icon: Tablet },
  { value: "Laptop", label: "Ordinateur", Icon: Laptop },
  { value: "Monitor", label: "Écran", Icon: Monitor },
  { value: "Tv", label: "TV", Icon: Tv },
  { value: "Watch", label: "Montre", Icon: Watch },
  { value: "Gamepad2", label: "Console", Icon: Gamepad2 },
  { value: "Headphones", label: "Écouteurs", Icon: Headphones },
  { value: "Speaker", label: "Enceinte", Icon: Speaker },
  { value: "Camera", label: "Caméra", Icon: Camera },
  { value: "Keyboard", label: "Clavier", Icon: Keyboard },
  { value: "Mouse", label: "Souris", Icon: Mouse },
  { value: "Printer", label: "Imprimante", Icon: Printer },
  { value: "Router", label: "Routeur / Box", Icon: Router },
  { value: "Wifi", label: "Réseau", Icon: Wifi },
  { value: "Cable", label: "Câble / Accessoire", Icon: Cable },
  { value: "Usb", label: "Port USB", Icon: Usb },
  { value: "Plug", label: "Chargeur", Icon: Plug },
  { value: "Battery", label: "Batterie", Icon: Battery },
  { value: "MemoryStick", label: "Mémoire", Icon: MemoryStick },
  { value: "HardDrive", label: "Disque dur", Icon: HardDrive },
  { value: "Cpu", label: "Composant", Icon: Cpu },
  { value: "Disc", label: "Disque / CD", Icon: Disc },
  { value: "Wrench", label: "Pièce détachée", Icon: Wrench },
  { value: "Zap", label: "Électronique", Icon: Zap },
  { value: "Lock", label: "Sécurité", Icon: Lock },
  { value: "ShieldCheck", label: "Protection", Icon: ShieldCheck },
  { value: "Package", label: "Autre", Icon: Package },
  { value: "PhoneCall", label: "Téléphonie", Icon: PhoneCall },
  { value: "Bluetooth", label: "Bluetooth", Icon: Bluetooth },
  { value: "Radio", label: "Radio", Icon: Radio },
  { value: "Antenna", label: "Antenne", Icon: Antenna },
  { value: "Webcam", label: "Webcam", Icon: Webcam },
  { value: "ScanLine", label: "Scanner", Icon: ScanLine },
  { value: "Projector", label: "Vidéoprojecteur", Icon: Projector },
  { value: "MonitorSpeaker", label: "Barre de son", Icon: MonitorSpeaker },
  { value: "Joystick", label: "Manette", Icon: Joystick },
  { value: "Dices", label: "Jeux de société", Icon: Dices },
  { value: "Puzzle", label: "Puzzle", Icon: Puzzle },
  { value: "Blocks", label: "Jouets de construction", Icon: Blocks },
  { value: "Baby", label: "Bébé", Icon: Baby },
  { value: "Backpack", label: "Sac à dos", Icon: Backpack },
  { value: "Briefcase", label: "Sacoche / Bureau", Icon: Briefcase },
  { value: "ShoppingBag", label: "Sac", Icon: ShoppingBag },
  { value: "ShoppingCart", label: "Épicerie", Icon: ShoppingCart },
  { value: "Shirt", label: "Vêtement", Icon: Shirt },
  { value: "Footprints", label: "Chaussures", Icon: Footprints },
  { value: "Glasses", label: "Lunettes", Icon: Glasses },
  { value: "Gem", label: "Bijou", Icon: Gem },
  { value: "Crown", label: "Accessoire luxe", Icon: Crown },
  { value: "Palette", label: "Cosmétique / Maquillage", Icon: Palette },
  { value: "Sparkles", label: "Parfumerie", Icon: Sparkles },
  { value: "Scissors", label: "Coiffure", Icon: Scissors },
  { value: "Brush", label: "Pinceau / Beauté", Icon: Brush },
  { value: "Droplet", label: "Soin / Liquide", Icon: Droplet },
  { value: "HeartPulse", label: "Santé", Icon: HeartPulse },
  { value: "Stethoscope", label: "Médical", Icon: Stethoscope },
  { value: "Pill", label: "Pharmacie", Icon: Pill },
  { value: "Syringe", label: "Injectable", Icon: Syringe },
  { value: "Bandage", label: "Premiers secours", Icon: Bandage },
  { value: "Thermometer", label: "Thermomètre", Icon: Thermometer },
  { value: "Dumbbell", label: "Musculation", Icon: Dumbbell },
  { value: "Bike", label: "Vélo", Icon: Bike },
  { value: "Bus", label: "Transport", Icon: Bus },
  { value: "Car", label: "Automobile", Icon: Car },
  { value: "CarFront", label: "Voiture", Icon: CarFront },
  { value: "Truck", label: "Utilitaire", Icon: Truck },
  { value: "Fuel", label: "Carburant", Icon: Fuel },
  { value: "Gauge", label: "Compteur", Icon: Gauge },
  { value: "Cog", label: "Mécanique", Icon: Cog },
  { value: "Settings", label: "Réglages", Icon: Settings },
  { value: "Hammer", label: "Bricolage", Icon: Hammer },
  { value: "Drill", label: "Perceuse", Icon: Drill },
  { value: "Ruler", label: "Mesure", Icon: Ruler },
  { value: "Nut", label: "Visserie", Icon: Nut },
  { value: "Paintbrush", label: "Peinture", Icon: Paintbrush },
  { value: "PaintRoller", label: "Rouleau", Icon: PaintRoller },
  { value: "Axe", label: "Outil de coupe", Icon: Axe },
  { value: "Shovel", label: "Jardinage", Icon: Shovel },
  { value: "TreePine", label: "Extérieur", Icon: TreePine },
  { value: "Trees", label: "Espaces verts", Icon: Trees },
  { value: "Flower2", label: "Fleurs", Icon: Flower2 },
  { value: "Leaf", label: "Plantes", Icon: Leaf },
  { value: "Sprout", label: "Jeunes plants", Icon: Sprout },
  { value: "Apple", label: "Fruits", Icon: Apple },
  { value: "Banana", label: "Fruits exotiques", Icon: Banana },
  { value: "Carrot", label: "Légumes", Icon: Carrot },
  { value: "Wheat", label: "Céréales", Icon: Wheat },
  { value: "Fish", label: "Poissonnerie", Icon: Fish },
  { value: "Beef", label: "Boucherie", Icon: Beef },
  { value: "Egg", label: "Œufs", Icon: Egg },
  { value: "Milk", label: "Produits laitiers", Icon: Milk },
  { value: "Cookie", label: "Biscuiterie", Icon: Cookie },
  { value: "Cake", label: "Pâtisserie", Icon: Cake },
  { value: "IceCreamCone", label: "Glaces", Icon: IceCreamCone },
  { value: "Coffee", label: "Café", Icon: Coffee },
  { value: "CupSoda", label: "Boissons", Icon: CupSoda },
  { value: "Wine", label: "Vin", Icon: Wine },
  { value: "Beer", label: "Bière", Icon: Beer },
  { value: "Martini", label: "Cocktail", Icon: Martini },
  { value: "GlassWater", label: "Eau / Verre", Icon: GlassWater },
  { value: "Utensils", label: "Restauration", Icon: Utensils },
  { value: "UtensilsCrossed", label: "Cuisine", Icon: UtensilsCrossed },
  { value: "ChefHat", label: "Cuisinier", Icon: ChefHat },
  { value: "Soup", label: "Plats préparés", Icon: Soup },
  { value: "Pizza", label: "Pizza", Icon: Pizza },
  { value: "Sandwich", label: "Snacking", Icon: Sandwich },
  { value: "Croissant", label: "Boulangerie", Icon: Croissant },
  { value: "Candy", label: "Confiserie", Icon: Candy },
  { value: "Popcorn", label: "Snack salé", Icon: Popcorn },
  { value: "Salad", label: "Bio / Frais", Icon: Salad },
  { value: "Drumstick", label: "Volaille", Icon: Drumstick },
  { value: "Ham", label: "Charcuterie", Icon: Ham },
  { value: "Cherry", label: "Fruits rouges", Icon: Cherry },
  { value: "Home", label: "Maison", Icon: Home },
  { value: "Building2", label: "Immobilier", Icon: Building2 },
  { value: "Warehouse", label: "Entrepôt", Icon: Warehouse },
  { value: "DoorOpen", label: "Porte", Icon: DoorOpen },
  { value: "Sofa", label: "Mobilier", Icon: Sofa },
  { value: "Armchair", label: "Fauteuil", Icon: Armchair },
  { value: "Bed", label: "Literie", Icon: Bed },
  { value: "BedDouble", label: "Chambre", Icon: BedDouble },
  { value: "Lamp", label: "Éclairage", Icon: Lamp },
  { value: "LampDesk", label: "Lampe de bureau", Icon: LampDesk },
  { value: "Refrigerator", label: "Électroménager", Icon: Refrigerator },
  { value: "Microwave", label: "Micro-ondes", Icon: Microwave },
  { value: "WashingMachine", label: "Lave-linge", Icon: WashingMachine },
  { value: "Fan", label: "Ventilation", Icon: Fan },
  { value: "Flame", label: "Chauffage", Icon: Flame },
  { value: "Droplets", label: "Plomberie", Icon: Droplets },
  { value: "ShowerHead", label: "Salle de bain", Icon: ShowerHead },
  { value: "Bath", label: "Sanitaire", Icon: Bath },
  { value: "Toilet", label: "WC", Icon: Toilet },
  { value: "Paintbrush2", label: "Décoration", Icon: Paintbrush2 },
  { value: "Frame", label: "Cadre / Déco", Icon: Frame },
  { value: "ImageIcon", label: "Image", Icon: ImageIcon },
  { value: "Image", label: "Photo / Cadre", Icon: Image },
  { value: "BookOpen", label: "Librairie", Icon: BookOpen },
  { value: "Book", label: "Livre", Icon: Book },
  { value: "Library", label: "Bibliothèque", Icon: Library },
  { value: "NotebookPen", label: "Papeterie", Icon: NotebookPen },
  { value: "PenTool", label: "Écriture", Icon: PenTool },
  { value: "Pencil", label: "Crayon", Icon: Pencil },
  { value: "Eraser", label: "Gomme", Icon: Eraser },
  { value: "Highlighter", label: "Surligneur", Icon: Highlighter },
  { value: "Paperclip", label: "Fournitures", Icon: Paperclip },
  { value: "FileText", label: "Documents", Icon: FileText },
  { value: "Folder", label: "Classement", Icon: Folder },
  { value: "Calculator", label: "Calcul", Icon: Calculator },
  { value: "Newspaper", label: "Presse", Icon: Newspaper },
  { value: "Music", label: "Musique", Icon: Music },
  { value: "Music2", label: "Instrument", Icon: Music2 },
  { value: "Guitar", label: "Guitare", Icon: Guitar },
  { value: "Piano", label: "Piano", Icon: Piano },
  { value: "Mic", label: "Micro", Icon: Mic },
  { value: "Mic2", label: "Karaoké", Icon: Mic2 },
  { value: "Film", label: "Cinéma / Vidéo", Icon: Film },
  { value: "Clapperboard", label: "Tournage", Icon: Clapperboard },
  { value: "Ticket", label: "Billetterie", Icon: Ticket },
  { value: "PartyPopper", label: "Fête", Icon: PartyPopper },
  { value: "Gift", label: "Cadeau", Icon: Gift },
  { value: "GiftIcon", label: "Emballage cadeau", Icon: GiftIcon },
  { value: "Sparkle", label: "Décoration festive", Icon: Sparkle },
  { value: "Snowflake", label: "Hiver", Icon: Snowflake },
  { value: "Sun", label: "Été", Icon: Sun },
  { value: "Umbrella", label: "Pluie / Plage", Icon: Umbrella },
  { value: "Waves", label: "Plage", Icon: Waves },
  { value: "Palmtree", label: "Vacances", Icon: Palmtree },
  { value: "Tent", label: "Camping", Icon: Tent },
  { value: "Compass", label: "Randonnée", Icon: Compass },
  { value: "Map", label: "Carte", Icon: Map },
  { value: "MapPin", label: "Localisation", Icon: MapPin },
  { value: "Luggage", label: "Bagagerie", Icon: Luggage },
  { value: "Plane", label: "Voyage / Aérien", Icon: Plane },
  { value: "Ship", label: "Bateau", Icon: Ship },
  { value: "Anchor", label: "Nautisme", Icon: Anchor },
  { value: "Sailboat", label: "Voile", Icon: Sailboat },
  { value: "Trophy", label: "Récompense / Sport", Icon: Trophy },
  { value: "Medal", label: "Compétition", Icon: Medal },
  { value: "Target", label: "Précision", Icon: Target },
  { value: "Volleyball", label: "Ballon", Icon: Volleyball },
  { value: "Award", label: "Trophée", Icon: Award },
  { value: "Flag", label: "Drapeau", Icon: Flag },
  { value: "PawPrint", label: "Animalerie", Icon: PawPrint },
  { value: "Bone", label: "Chien", Icon: Bone },
  { value: "Cat", label: "Chat", Icon: Cat },
  { value: "Dog", label: "Chien", Icon: Dog },
  { value: "Bird", label: "Oiseau", Icon: Bird },
  { value: "Rabbit", label: "Rongeur / Lapin", Icon: Rabbit },
  { value: "Turtle", label: "Reptile / Aquarium", Icon: Turtle },
  { value: "Squirrel", label: "Faune", Icon: Squirrel },
  { value: "Feather", label: "Plumes / Literie", Icon: Feather },
  { value: "ToyBrick", label: "Jouet", Icon: ToyBrick },
  { value: "Users", label: "Famille", Icon: Users },
  { value: "Star", label: "Nouveautés", Icon: Star },
  { value: "Tag", label: "Promotion", Icon: Tag },
  { value: "Percent", label: "Soldes", Icon: Percent },
  { value: "BadgeDollarSign", label: "Bon plan", Icon: BadgeDollarSign },
  { value: "Wallet", label: "Paiement", Icon: Wallet },
];

const ICON_MAP = CATEGORY_ICON_OPTIONS.reduce((acc, o) => { acc[o.value] = o.Icon; return acc; }, {});

export function getCategoryIconComponent(iconValue) {
  return ICON_MAP[iconValue] || Package;
}

// Sous-catégories (voir Administrateurs > Catégories) : une sous-catégorie
// n'a pas sa propre icône affichée sur les articles — l'icône reste celle de
// sa catégorie PRINCIPALE, pour que tous les articles d'une même famille
// (ex. toutes les coques, quel que soit leur modèle exact) restent
// visuellement reconnaissables d'un coup d'œil dans le stock.
export function resolveCategoryForIcon(categories, categoryName) {
  const cat = (categories || []).find((c) => c.nom === categoryName);
  if (!cat) return null;
  if (cat.parent_id) {
    return (categories || []).find((c) => c.id === cat.parent_id) || cat;
  }
  return cat;
}

// Fil d'Ariane d'une catégorie pour l'affichage (ex. recherche d'article) :
// "Coques" pour une catégorie de premier niveau, "Coques → Magsafe" pour une
// sous-catégorie.
export function getCategoryBreadcrumb(categories, categoryName) {
  const cat = (categories || []).find((c) => c.nom === categoryName);
  if (!cat) return categoryName || "";
  if (cat.parent_id) {
    const parent = (categories || []).find((c) => c.id === cat.parent_id);
    if (parent) return `${parent.nom} → ${cat.nom}`;
  }
  return cat.nom;
}

// Affiche l'icône d'une catégorie : une image téléversée (icon_type "image") ou une
// icône Lucide (icon_type "lucide", par défaut). `uploadsBase` doit être fourni pour
// résoudre les URLs d'image relatives (UPLOADS_BASE de lib/api).
export function CategoryIcon({ category, uploadsBase = "", size = 20, className = "" }) {
  if (!category) return <Package size={size} className={className} />;
  if (category.icon_type === "image" && category.icon_value) {
    return <img src={`${uploadsBase}${category.icon_value}`} alt={category.nom} className={`object-contain ${className}`} style={{ width: size, height: size }} />;
  }
  const Icon = getCategoryIconComponent(category.icon_value);
  return <Icon size={size} className={className} />;
}
